import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";
import { useCart } from "@/context/CartContext";

const CATS = ["all", "Kits pédagogiques", "Goodies"];

export default function Boutique() {
  const [products, setProducts] = useState([]);
  const [cat, setCat] = useState("all");
  const { count } = useCart();

  useEffect(() => {
    const params = {};
    if (cat !== "all") params.category = cat;
    api.get("/products", { params }).then((r) => setProducts(r.data)).catch(() => {});
  }, [cat]);

  return (
    <div>
      <section className="bg-gradient-to-b from-rose-50 to-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-wrap items-end justify-between gap-6">
          <div>
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-rose-500">Boutique</span>
            <h1 className="font-heading font-black text-4xl sm:text-5xl lg:text-6xl text-slate-900 mt-2">
              Kits & goodies Kwarizmix
            </h1>
            <p className="mt-4 text-lg text-slate-600 max-w-xl">
              Prolongez l'aventure à la maison ou en classe avec nos ressources pédagogiques.
            </p>
          </div>
          {count > 0 && (
            <Link
              to="/panier"
              data-testid="boutique-cart-link"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-slate-900 text-white font-bold hover:bg-sky-600 transition-colors"
            >
              <ShoppingBag className="w-5 h-5" /> Voir mon panier ({count})
            </Link>
          )}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="flex flex-wrap gap-2 mb-8">
          {CATS.map((c) => (
            <button
              key={c}
              onClick={() => setCat(c)}
              data-testid={`boutique-cat-${c}`}
              className={`px-5 py-2.5 rounded-full text-sm font-bold transition-[transform,background-color] hover:scale-105 ${
                cat === c ? "bg-rose-400 text-white shadow-lg shadow-rose-400/30" : "bg-white border border-slate-200 text-slate-600 hover:border-rose-300"
              }`}
            >
              {c === "all" ? "Tout" : c}
            </button>
          ))}
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="products-grid">
          {products.map((p, i) => (
            <ProductCard key={p.id} product={p} index={i} />
          ))}
        </div>
      </section>
    </div>
  );
}
